import { utils, t } from '@hh/global.js'

const { prefersReducedMotion, isTablet } = utils
class HHMobileMenu extends HTMLElement {
  constructor() {
    super()

    this._open = false

    this.toggleFn = this.toggleFn.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.handleOutsideEvent = this.handleOutsideEvent.bind(this)
    this.onKeyup = this.onKeyup.bind(this)
  }

  connectedCallback() {
    this.toggle = this.querySelector('.js-mobile-trigger')
    this.menu = this.querySelector('.js-mobile-menu-container')

    this.toggle.addEventListener('click', this.toggleFn)
    document.addEventListener('focusin', this.handleOutsideEvent)
    this.addEventListener('keyup', this.onKeyup)
  }

  disconnectedCallback() {
    this.toggle.removeEventListener('click', this.toggleFn)
    document.removeEventListener('focusin', this.handleOutsideEvent)
    this.removeEventListener('keyup', this.onKeyup)
  }

  onKeyup(e) {
    if (e.code.toUpperCase() === 'ESCAPE') this.toggle.click()
  }

  toggleFn(e) {
    e.preventDefault()
    this._open ? this.close() : this.open()
  }

  open() {
    this._open = true
    this.addBodyListener()
    this.toggle.setAttribute('aria-expanded', true)
    this.toggle.setAttribute(
      'aria-label',
      t('accessibility.close_mobile_menu', 'Close mobile menu')
    )
    this.broadcast(true)
  }

  close() {
    this._open = false
    this.removeBodyListener()
    this.toggle.setAttribute('aria-expanded', false)
    this.toggle.setAttribute(
      'aria-label',
      t('accessibility.open_mobile_menu', 'Open mobile menu')
    )
    this.broadcast(false)
  }

  addBodyListener() {
    document.body.classList.add('scroll-lock')
    document.querySelector('html').classList.add('scroll-lock')
  }

  removeBodyListener() {
    document.body.classList.remove('scroll-lock')
    document.querySelector('html').classList.remove('scroll-lock')
  }

  broadcast(e) {
    this.dispatchEvent(
      new CustomEvent('mobileMenuOpened', {
        bubbles: true,
        composed: true,
        detail: {
          value: e,
        },
      })
    )
  }

  handleOutsideEvent(e) {
    if (!this.contains(e.target) && this._open) {
      this.toggle.click()
    }
  }
}

customElements.define('hh-mobile-menu', HHMobileMenu)
